import LogoutModal from "@app/components/logout-modal";
import MenuLinkItem from "@app/components/menu-link-item";
import {
  Menu,
  MenuCompany,
  PathnameUrl,
  Role,
  USER_INFO_KEY,
} from "@app/constants";
import { openPortalDialog } from "@app/services/modal.service";
import SocketService from "@app/services/socket.service";
import StorageService from "@core/services/storage";
import { useEffect } from "react";
import { CiLogout } from "react-icons/ci";
import { Outlet, useNavigate } from "react-router-dom";

function MainLayout() {
  const navigate = useNavigate();

  const acc = StorageService.getObject(USER_INFO_KEY) as any;

  if (!acc) {
    navigate(PathnameUrl.LOGIN);
  }

  //connect socket
  useEffect(() => {
    SocketService.connect();
    SocketService.emit("join", "admin");
  }, []);

  const onLogoutClick = () => {
    const logoutModalObs = openPortalDialog(LogoutModal);

    logoutModalObs.afterClosed().subscribe((data) => {
      if (data?.isAccept) {
        localStorage.clear();
        window.location.reload();
        // navigate(PathnameUrl.LOGIN);
      }
    });
  };

  return (
    <div className="flex w-full h-[100vh]">
      <div className="fixed left-0 top-0 p-2 pt-5 flex flex-col transition-all w-[200px] h-full bg-[#1e2329] border-solid border-[#eee]">
        {acc?.role === Role.ADMIN
          ? Menu.map((item, index) => (
              <MenuLinkItem key={index} {...item} onMenuItemClick={() => {}} />
            ))
          : MenuCompany.map((item, index) => (
              <MenuLinkItem key={index} {...item} onMenuItemClick={() => {}} />
            ))}
        <div
          className="flex items-center gap-2 text-white cursor-pointer ml-2 mt-2"
          onClick={onLogoutClick}
        >
          <CiLogout className="text-[20px] text-center" /> Đăng xuất
        </div>
      </div>
      <div className="ml-[200px] w-full">
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
